/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'
import { persistentState } from 'common/utils/types/helpers'
import packageInfo from '../../../package.json'

interface XHRProps {
  url: string
  method: 'GET' | 'POST' | 'PUT' | 'DELETE'
  parameters?: any
  data?: any
}

export default function xhr({ url, method, parameters, data }: XHRProps) {
  const deviceCode = persistentState.device.getRaw('deviceCode')

  return axios({
    url,
    method,
    data: {
      client: {
        device: deviceCode,
        code: deviceCode,
        locale: 'en',
        target: 'web',
        version: packageInfo.version,
      },
      ...data,
    },
    params: parameters,
  })
}
